/* eslint-disable no-nested-ternary */
import {
  formatMMtoHHMM,
  timestampToDisplay,
} from '@mummssoftware/utils/formatters';
import { countMap } from '../Context/constants';
import { sortAlphaByName } from '../Context/visitLogUtils';

export const effectiveDateValueGetter = (params: any) => {
  if (!params?.data?.effectivedatetime_shifted) return '';
  return timestampToDisplay(params?.data?.effectivedatetime_shifted);
};

export const dateValueGetter = (params: any) => {
  if (!params?.data?.effectivedatetime_shifted) return '';
  return timestampToDisplay(params?.data?.effectivedatetime_shifted);
};

export const largeProviderValueGetter = (params: any) => {
  if (!params?.data?.personlastname || !params?.data?.personfirstname)
    return '';

  const {
    data: { personfirstname, personlastname, personcredentials },
  } = params;
  return `${personlastname}, ${personfirstname}${
    (personcredentials && `, ${personcredentials}`) || ''
  }`;
};
export const smallProviderValueGetter = (params: any) => {
  if (!params?.data?.personlastname || !params?.data?.personfirstname)
    return '';

  const {
    data: { personfirstname, personlastname, personcredentials },
  } = params;
  return `${personfirstname.slice(0, 1).toUpperCase()}. ${personlastname
    .slice(0, 1)
    .toUpperCase()}. ${(personcredentials && `${personcredentials}`) || ''}`;
};

export const patientFirstNameValueGetter = (params: any) => {
  if (!params?.data?.patientlastname) return '';

  const {
    data: { patientfirstname },
  } = params;
  return `${patientfirstname}`;
};
export const patientLastNameValueGetter = (params: any) => {
  if (!params?.data?.patientfirstname) return '';

  const {
    data: { patientlastname },
  } = params;
  return `${patientlastname}`;
};

export const durationValueGetter = (params: any) => {
  if (!params?.data?.durationmins) return '';
  const { durationmins } = params?.data;
  return formatMMtoHHMM(durationmins);
};

const getLateChartingMins = (data: any) =>
  data?.latechartingmins ?? data?.visitDetails?.latechartingmins;

export const lateChartingValueGetter = (params: any) => {
  const mins = getLateChartingMins(params?.data);
  if (mins == null || mins === '') {
    return '';
  }
  const numMins = Number(mins);
  if (!Number.isFinite(numMins) || numMins <= 0) {
    return '';
  }
  return `${Math.ceil(numMins / 60)}h`;
};

export const lateChartingTooltipValueGetter = (params: any) => {
  const mins = getLateChartingMins(params?.data);
  if (mins == null || mins === '') {
    return '';
  }
  const numMins = Number(mins);
  if (!Number.isFinite(numMins) || numMins <= 0) {
    return '';
  }
  return formatMMtoHHMM(numMins);
};

export const visitTypeGetter = (params: any) => {
  const {
    data: { compiledvisittype },
  } = params;
  return compiledvisittype;
};

export const roleCodeGetter = (params: any) => {
  const {
    data: { compiledvisittype },
  } = params;
  return compiledvisittype.split('-')[0];
};

export const typeCodeGetter = (params: any) => {
  const {
    data: { compiledvisittype },
  } = params;
  return compiledvisittype.split('-')[1];
};

export const locCodeGetter = (params: any) => {
  const {
    data: { compiledvisittype },
  } = params;
  return compiledvisittype.split('-')[2];
};

export const locationCodeGetter = (params: any) => {
  const {
    data: { compiledvisittype },
  } = params;
  return compiledvisittype.split('-')[3];
};

export const patientMeasureMapper = (patientMeasures: any) =>
  `
  ${patientMeasures
    .map(
      (measure: any) =>
        `${measure.typeshortname}: ${
          (measure.typeshortname === 'bp' && measure.displayvalue) ||
          (measure.typeshortname === 'fast' && measure.enteredvalue) ||
          measure.value
        }${
          (measure.units === '0-100' && '/100') ||
          (measure.units === '%' && '%') ||
          (measure.units === '1-7f' && ' ') ||
          (measure.units && ` ${measure.units}`) ||
          ''
        }`,
    )
    .join(',\n')}`;

export const filterFormsByStatus = (forms: any, status: string) =>
  forms.filter((form: any) => form.status === status);

export const countValueGetter = (rowNode: any) => {
  const { visitDetails, facetofacevisit, isfacetofaceallowed } = rowNode?.data;
  const { data } = rowNode;
  const { field } = rowNode.column.colDef;
  let count = 0;
  if (field === 'F2F') {
    return facetofacevisit ? 1 : isfacetofaceallowed ? '0' : '';
  }
  const detailProp = countMap.get(field) || '';

  if (data[detailProp]) {
    count = Number(data[detailProp]);
  } else if (visitDetails && visitDetails[detailProp]) {
    count = Number(visitDetails[detailProp]);
  }
  return (count > 0 && count) || '';
};

/** Plain selected attribute names for CSV/Excel export (DotRenderer has no export value). */
export const selectedAttributesExportValueGetter = (params: any) => {
  const visit = params?.data;
  if (!visit) return '';
  const raw =
    visit.visitDetails?.visitattrsumdto ||
    visit.visitattrsumdto ||
    visit.visitattributes;
  if (!raw) return '';
  try {
    const atts = JSON.parse(raw);
    if (!Array.isArray(atts)) return '';
    return atts
      .filter((a: any) => a?.isselected)
      .sort(sortAlphaByName)
      .map((a: any) => a?.name || '')
      .filter(Boolean)
      .join('; ');
  } catch {
    return '';
  }
};
